// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs_tabs__tVXxO","tab":"Tabs_tab__HeYbT","active":"Tabs_active__xSwfW","tab-tag":"Tabs_tab-tag__D6O6D"};